module.exports = __webpack_public_path__ + "images/giftTree/birth.5acab000f112562525a2974b54dc514d.png";